import { FAVORITE_ITEM_LOADED } from "./actions";
import { FAVORITE_ITEM_ERROR, FAVORITE_ITEM_REMOVE } from "./actions";

const defaultState = {
  favorites: [],
  error: null
};

const updateFavorites = (favorites, item) => {
  return [...favorites, item];
};

const removeItem = (favorites, id) => {
  const idx = favorites.findIndex(item => item.id === id);
  return [...favorites.slice(0, idx), ...favorites.slice(idx + 1)];
};

export const favoritesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FAVORITE_ITEM_LOADED:
      return {
        favorites: updateFavorites(state.favorites, action.payload),
        error: null
      };

    case FAVORITE_ITEM_ERROR:
      return {
        favorites: [],
        error: true
      };

    case FAVORITE_ITEM_REMOVE:
      return {
        favorites: removeItem(state.favorites, action.payload),
        error: null
      };

    default:
      return state;
  }
};
